import { ConfigProvider } from 'effect'

import type {
  NextPublicEnvironment,
  PublicEnvironment,
} from './environment/public.environment.ts'

export const NextPublicConfigProvider = ConfigProvider.fromUnknown({
  PUBLIC_APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,
  PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
  PUBLIC_SENTRY_RELEASE: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
  PUBLIC_SUPABASE_URL: process.env.NEXT_PUBLIC_SUPABASE_URL,
  PUBLIC_SUPABASE_ANON_KEY: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
  PUBLIC_API_ENDPOINT: process.env.NEXT_PUBLIC_API_ENDPOINT,
  PUBLIC_OTEL_SERVICE_NAME: process.env.NEXT_PUBLIC_OTEL_SERVICE_NAME,
  NEXT_RUNTIME: process.env.NEXT_RUNTIME,
} satisfies PublicEnvironment & Pick<NextPublicEnvironment, 'NEXT_RUNTIME'>)

export const PublicConfigProviderLayer = ConfigProvider.layer(
  NextPublicConfigProvider.pipe(
    ConfigProvider.orElse(ConfigProvider.fromEnv()),
  ),
)
